import { makeStyles } from "@mui/styles";

const commentsStyles = makeStyles((theme) => ({
    container: {
        padding: "4rem 2rem",
        paddingLeft: '7rem',
        paddingRight: '7rem',
        paddingTop: '5.5rem',
        backgroundColor: theme.palette.background.gray,
        [theme.breakpoints.down('lg')]: {
            paddingLeft: '6rem',
            paddingRight: '6rem',
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '3.5rem',
            paddingRight: '3.5rem',
            alignItems: "center",
        },
    },
    title: {
        fontWeight: "bold",
        marginBottom: "1.8rem !important",
        color: theme.palette.text.primary,
        textAlign: "left",
        [theme.breakpoints.down('lg')]: {
            paddingTop:"0rem",
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: "center",
            fontSize: "2.4rem!important",
            paddingTop:"0.6rem",
            paddingBottom: "1.2rem",
        },
    },
    paragraph: {
        fontSize: "1.2rem !important",
        color: theme.palette.text.lightGray,
        marginBottom: "4rem !important",
        textAlign: "left",
        [theme.breakpoints.down('lg')]: {
            fontSize: "1.2rem !important",
            paddingTop:"1rem",
        },
          [theme.breakpoints.down('sm')]: {
            textAlign: "justify",
            fontSize: "1.4rem !important",
        },
    },
    commentsContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "20px",
        [theme.breakpoints.down('sm')]: {
            padding:"0rem",
            gap: "5px",
        },
    },
    commentCard: {
        maxWidth: "350px",
        padding: "20px",
        boxShadow: "3px 3px 10px rgba(0, 0, 0, 0.2)",
        borderRadius: "15px",
        textAlign: "center",
    },
    userName: {
        fontWeight: "bold !important",
        marginTop: "2rem !important",
        [theme.breakpoints.down('sm')]: {
            fontSize:'1.35rem!important',
        },
    },
    commentText: {
        paddingLeft: '1.2rem',
        paddingRight: '1.2rem',
        fontStyle: "italic",
        color: 'rgb(129, 128, 128)',
        marginBottom: '2rem !important',
        marginTop: '2rem !important',
        [theme.breakpoints.down('sm')]: {
            fontSize:'1.15rem!important',
        },
    },
    quoteIcon: {
        fontSize: "2.6rem !important",
        marginBottom: "1.5rem",
        marginTop: "1rem",
    },
    mobileCommentWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        width: "100%",
        position: "relative",
    },
    navButton: {
        backgroundColor: "#ddd",
        borderRadius: "50%",
        padding: "0.5rem",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#bbb",
        },
    },
    disabledButton: {
        opacity: 0.4,
        cursor: "not-allowed",
    },
    desktopComments: {
        display: "flex",
        gap: "2rem",
    },
}));

export default commentsStyles;
